import { IRealityCheckInput } from "./types";
import { OperatorEvent } from "../interfaces/theos.interface";
import { registerEventHandler } from "./registerEventHandler";

/**
 * Needs to be handled only when not using the Relax game server. Otherwise FEIM handles this internally.
 *
 * When triggered, call the corresponding endpoint of the game server, which then forwards the choice to Relax P2P API.
 *
 * Note! If the player chose to continue, an unfreeze event will also be triggered at the same time with this. However,
 * the game should actually only continue once an answer for the aforementioned endpoint request is received.
 */
export const onRealityCheckChoiceRequired = (callback: (choice: IRealityCheckInput) => void): void =>
{
    registerEventHandler<IRealityCheckInput>(OperatorEvent.P2P_RC_CHOICE)(callback);
};